import { render, staticRenderFns } from "./BookingPositionModal.vue?vue&type=template&id=b6c54254&"
import script from "./BookingPositionModal.vue?vue&type=script&lang=js&"
export * from "./BookingPositionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports